import { createNamespacedHelpers } from 'vuex';
import files from './filesStore';

const store = {
  namespaced: true,
  modules: {
    files,
  },
};

export const { mapGetters } = createNamespacedHelpers('uploads');

export default store;
